import { format } from 'date-fns'

export const getClientTime = () => {
  return encodeURIComponent(
    `${format(new Date(), 'yyyy-MM-ddxx').replace(':', '')}`,
  )
}
